export const createSlug = (text) => {
    return text
        .toLowerCase()
        .normalize("NFD")                  // separa las tildes
        .replace(/[\u0300-\u036f]/g, "")   // elimina las tildes
        .replace(/ñ/g, "n")
        .replace(/[^a-z0-9\s-]/g, "")      // elimina símbolos
        .trim()
        .replace(/\s+/g, "-")              // espacios -> -
        .replace(/-+/g, "-");              // evita -- dobles
};